import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import "./index.css";
import App from "./App.jsx";
import "bootstrap/dist/css/bootstrap.min.css";
import "@fortawesome/fontawesome-free/css/all.min.css";
import "@fortawesome/fontawesome-free/css/v4-shims.min.css";
import { ThemeProvider } from "./ThemeContext";
import { AuthProvider } from "./context/AuthContext";
import { PinProvider } from "./context/PinContext";


createRoot(document.getElementById("root")).render(
  <StrictMode>
    <AuthProvider>
      <PinProvider>
        <ThemeProvider>
          <App />
        </ThemeProvider>
      </PinProvider>
    </AuthProvider>
  </StrictMode>
);
